import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../layout/index.vue";

Vue.use(VueRouter);

// 保存原有的 push 方法
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") {
      throw err; // 其他错误抛出
    }
  });
};

// 保存原有的 replace 方法
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function (location) {
  return originalReplace.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") {
      throw err; // 其他错误抛出
    }
  });
};

const routes = [
  {
    path: "",
    component: Layout,
    children: [
      {
        path: "/",
        component: () => import("@/views/home/index.vue"),
        name: "home",
        meta: {
          noNavBorder: true,
        },
      },
      {
        path: "/purchase",
        component: () => import("@/views/projectInfo/index.vue"),
        name: "purchaseList",
        children: [
          {
            path: "list/:code",
            component: () => import("@/views/projectInfo/list.vue"),
            name: "projectList",
          },
          {
            path: "detail/:code",
            component: () => import("@/views/projectInfo/detail.vue"),
            name: "projectDetail",
          },
        ],
      },
      {
        path: "/porperty",
        component: () => import("@/views/porpertyInfo/index.vue"),
        name: "porpertyList",
        children: [
          {
            path: "list/:code",
            component: () => import("@/views/porpertyInfo/list.vue"),
            name: "porpertyList",
          },
          {
            path: "detail/:code",
            component: () => import("@/views/porpertyInfo/detail.vue"),
            name: "porpertyDetail",
          },
        ],
      },
      {
        path: "/info",
        component: () => import("@/layout/SideNavLayout.vue"),
        name: "info",
        children: [
          {
            path: "list/:code",
            component: () => import("@/views/info/list.vue"),
            name: "infoList",
          },
          {
            path: "detail/:code",
            component: () => import("@/views/info/detail.vue"),
            name: "infoDetail",
          },
          {
            path: ":code",
            component: () => import("@/views/info/_code.vue"),
            name: "CodeDetail",
          },
        ],
      },
      {
        path: "/notice",
        component: () => import("@/layout/SideNavLayout.vue"),
        name: "notice",
        children: [
          {
            path: "list/:code",
            component: () => import("@/views/notice/list.vue"),
            name: "noticeList",
          },
          {
            path: "detail/:code",
            component: () => import("@/views/notice/detail.vue"),
            name: "noticeDetail",
          },
          {
            path: ":code",
            component: () => import("@/views/notice/_code.vue"),
            name: "CodeDetail",
          },
        ],
      },
      {
        path: "/ad",
        name: "ad",
        component: () => import("@/views/ad/index.vue"),
        children: [
          {
            path: "list/:code",
            component: () => import("@/views/ad/list.vue"),
            name: "infoList",
          },
        ],
      },
      {
        path: "/recentOpenBidding",
        component: () => import("@/layout/SideNavLayout.vue"),
        name: "recentOpenBidding",
        children: [
          {
            path: "list/:code",
            component: () => import("@/views/recentOpenBidding/list.vue"),
            name: "recentOpenBiddingList",
          },
        ],
      },
      {
        path: "/friendlyLink",
        component: () => import("@/layout/SideNavLayout.vue"),
        name: "friendlyLink",
        children: [
          {
            path: "list/:code",
            component: () => import("@/views/friendlyLink/index.vue"),
            name: "friendlyLinkList",
          },
        ],
      },
      {
        name: "searchResult",
        path: "/searchResult",
        component: () => import("@/views/searchResult/index.vue"),
      },
    ],
  },
  {
    name: "projectScroll",
    path: "/projectScroll",
    component: () => import("@/views/projectScroll/index.vue"),
    meta: {
      hideBreadcrumb: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

export default router;
